import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useLoginMutation } from "../../../services/api";
import { setCredentials } from "../../../store/slices/authSlice";
import ErrorMessage from "../../../Components/common/ErrorMessage";
import "./AdminLogin.css";

const AdminLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [login, { isLoading, error }] = useLoginMutation();
  const [customError, setCustomError] = useState(null);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setCustomError(null); // Clear custom error when user types
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCustomError(null);

    try {
      const response = await login(formData).unwrap();

      // Check if user has admin dashboard access (Staff level 3+ or Admin level 4+)
      const roleLevel = response.user?.role?.level || 0;
      if (roleLevel < 3) {
        setCustomError({
          data: {
            message: "Access Denied: You do not have staff or administrator privileges. Please use the regular login page.",
          },
        });
        return;
      }

      // Save credentials to Redux (automatically persisted)
      dispatch(setCredentials(response));

      // Navigate to admin dashboard
      navigate("/admin/dashboard");
    } catch (err) {
      console.error("Admin login failed:", err);
      // Error handled by RTK Query
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <div className="admin-login-card">
          <div className="admin-login-header">
            <div className="admin-badge">Administrator</div>
            <h1>Admin Portal</h1>
            <p>Sign in with your administrator credentials</p>
          </div>

          {(error || customError) && <ErrorMessage error={customError || error} />}

          <form onSubmit={handleSubmit} className="admin-login-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
              />
            </div>

            <button
              type="submit"
              className="admin-login-btn"
              disabled={isLoading}
            >
              {isLoading ? "Signing in..." : "Sign In to Admin Portal"}
            </button>
          </form>

          <div className="admin-login-footer">
            <p className="security-notice">
              This is a secure area. All login attempts are monitored.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
